// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ScannerImagesButton[data-v-1f01bae8] {\n  margin-left: 8px;\n}\n.ScannerImagesButton[data-v-1f01bae8]  .dropdown-menu {\n  min-width: 0;\n}\n.ScannerImagesButton__Icon[data-v-1f01bae8] {\n  display: inline-flex;\n  align-items: center;\n  color: #0091ae;\n  font-size: 14px;\n}\n.ScannerImagesButton__Count[data-v-1f01bae8] {\n  font-size: 12px;\n  font-weight: bold;\n}\n.ScannerImagesDrop[data-v-1f01bae8] {\n  direction: rtl;\n  text-align: right;\n  padding: 0.3rem 0.5rem;\n}\n", ""]);
// Exports
module.exports = exports;
